import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { BpgExpensesService } from '../bpg-expenses.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingDTOModel, FilterModel } from "../../bpg-common/services/data.services";
import { Location } from '@angular/common';
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { UploadService } from 'src/app/bpg-self-services/d-i/upload.service';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
@Component({
  selector: 'app-create-and-edit-expense-claim',
  templateUrl: './create-and-edit-expense-claim.component.html',
  styleUrls: ['./create-and-edit-expense-claim.component.css']
})
export class CreateAndEditExpenseClaimComponent implements OnInit {
  expenseClaimForm: FormGroup;
  chaptersList: any;
  uploadDocumentConstant = "Upload document";
  fileName: string = this.uploadDocumentConstant;
  fileExtension: any;
  fileExtensionError = false;
  fileSize: number;
  fileSizeExtensionError = false;
  loginData = JSON.parse(localStorage.getItem('loginData'));
  userAndRoleIdDTO = {
    userId: this.loginData['userId'],
    roleId: localStorage.getItem('adminId')
  }
  chapterDropDownList: any;
  HoshinDropDownList: any;
  selectedFiles: File[] = [];
  alertSuccess: boolean;
  editEventData: any;
  actionTitle: any;
  msg1: string;
  msg2: string;
  method: string;
  param: string;
  landingData: any;
  eventList: any;
  expenseClaim: any = JSON.parse(sessionStorage.getItem('expenseNameAndChapterId'));
  eventDateNameList: any = [];
  eventListObj: any[] = [];
  editExpenseData: any = JSON.parse(sessionStorage.getItem('editExpenseData'));
  alertFailure: boolean;


  supportingDoc1File: File = null;
  supportingDoc2File: File = null;
  supportingDoc3File: File = null;
  supportingDoc4File: File = null;
  supportingDoc1Name: string = this.uploadDocumentConstant;
  supportingDoc2Name: string = this.uploadDocumentConstant;
  disable: boolean;
  landingDTOModel: LandingDTOModel = new LandingDTOModel();
  filter: FilterModel = new FilterModel();
  HoshinDropDown: any;
  selectedHoshinItems: any;
  actionTitleHoshin: any;
  hoshinId: any;
  alertSuccessOnSave: boolean;
  timeOutError: boolean;
  buttonType: any;
  adminId: any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  awsUrls: any;
  uploadFlag: any;
  finalExpenseData: any = []
  isbpgAdmin = false;
  isNaacAdmin = false;
  eventId: any;
  /**
  * @class CreateAndEditExpenseClaimComponent
  * @constructor
  */
  constructor(private readonly formBuilder: FormBuilder,
    private readonly bpgEventService: BpgEventsService,
    private readonly router: Router,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly route: ActivatedRoute,
    private readonly location: Location,
    private readonly bpgExpensesService: BpgExpensesService,
    private readonly environment: EnvironmentConfiguration,
    private readonly bpgCommonService: BpgCommonService,
    private readonly uploadService: UploadService) { }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
      if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
        this.router.navigate(['/log-out']);
      }
    }

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 500);

    if (localStorage.getItem('isbpgAdmin') === 'true') {
      this.isbpgAdmin = true
    }
    if (localStorage.getItem('isNaacAdmin') === 'true') {
      this.isNaacAdmin = true
    }
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== '3' && this.adminId !== '4' && !this.isNaacAdmin && !this.isbpgAdmin) {
      this.router.navigate(['/site-home']);
    }

    this.bpgCommonService.getSessionToken();

    this.HoshinDropDownList = [{ hoshinType: "Community Engagement" }, { hoshinType: "Workforce Readiness" },
    { hoshinType: "Team Member Engagement" }, { hoshinType: "Business Support" }]
    // newly added
    this.route.params.subscribe((params) => {
      console.log(params.id);
      // bring expense data and set it here
      if (params.id != null && params.id != undefined) {
        this.bpgExpensesService.getExpenseById(params.id).subscribe(data => {
          if (data != null) {
            this.spinner.hide();
            this.editExpenseData = data;
            this.buildForms();
          }
        }, err => {
          this.spinner.hide();
          if (err.value.statusText === ConstantValues.unknownError) {
            this.timeOutError = true;
          }
        });
      }
    });

    // newly added ends
    this.bpgEventService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
      this.chapterDropDownList = data;
      this.chapterDropDownList.map((i) => { i.siteName = `${i.siteName}-${i.bpgName}`; return i; })
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

    this.buildForms();

    if (this.expenseClaim != null) {
      this.disable = true;
      this.getEventListBasedOnChapterSelection(this.expenseClaim.chapterId, this.expenseClaim.eventId);
      this.getHoshinItemsBasedOnChapterSelection(this.expenseClaim.chapterId, this.expenseClaim.eventId, this.expenseClaim.hoshinId);
      this.expenseClaimForm.patchValue({
        chapterId: this.expenseClaim.chapterId,
        eventId: this.expenseClaim.eventId

      });
    }
  }

  /** For getting event list for dropdown
 * @class CreateAndEditExpenseClaimComponent
 * @method getEventListBasedOnChapterSelection
 * @params chapterId
 */
  public getEventListBasedOnChapterSelection(chapterId, eventId) {
    this.expenseClaimForm.controls['eventId'].setValue(null);
    this.landingData = {
      "filter": {
        "chapterId": chapterId,
        "eventId": eventId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 100,
      "sortDirection": "ASC",
      "sortProperty": "event_create_date",
      "uid": ""
    }
    this.bpgEventService.getAllEvents(this.landingData).subscribe(data => {
      this.eventList = data.content;

    })
  }

  /** For adding 365 days to current day
   * @class CreateAndEditExpenseClaimComponent
   * @method addDays
   * @params Date, number
   */
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }


  /** For building add event form
     * @class CreateAndEditExpenseClaimComponent
     * @method buildForms
     */
  private buildForms(): void {

    this.expenseClaimForm = this.formBuilder.group({
      expenseId: null,
      chapterId: [null, Validators.required],
      hoshinType: [null, Validators.required],
      isEventExpense: [true, Validators.required],
      eventId: [null, Validators.required],
      hoshinId: [null, Validators.required],
      expenseName: [null, Validators.required],
      totalExpense: [null, Validators.required],
      expenseDesc: [null, Validators.required],
      // detailedEventPurpose: [null, Validators.required],
      supportingDoc1: null,
      supportingDoc2: null,
      supportingDoc3: null,
      supportingDoc4: null,
      expenseClaimedBy: this.loginData['userId'],
      isSubmitted: false,
      expenseStatus: "",
      userID: null,
    });
    if (this.editExpenseData != null) {

      if (this.editExpenseData.chapterId != null) {
        this.getEventListBasedOnChapterSelection(this.editExpenseData.chapterId, this.editExpenseData.eventId);
      }

      if (this.editExpenseData.supportingDoc1 != null) {
        this.supportingDoc1Name = this.editExpenseData.supportingDoc1;
      }
      if (this.editExpenseData.supportingDoc2 != null) {
        this.supportingDoc2Name = this.editExpenseData.supportingDoc2;
      }

      if (this.editExpenseData.isEventExpense === true) {
        this.eventId = this.editExpenseData.eventId;
        this.expenseClaimForm.controls['eventId'].enable();
      } else if (this.editExpenseData.isEventExpense === false) {
        this.editExpenseData.eventId = null;
        this.expenseClaimForm.controls['eventId'].disable();
      }
      this.hoshinId = this.editExpenseData.hoshinId;
      this.getHoshinItemsBasedOnChapterSelection(this.editExpenseData.chapterId, this.editExpenseData.eventId, this.editExpenseData.hoshinId);

      this.actionTitle = "EDIT";
      this.expenseClaimForm.patchValue(this.editExpenseData);
    }
    else {
      this.actionTitle = "";
    }

  }

  /** To set filename
* @class CreateAndEditExpenseClaimComponent
* @method onFileSelected
*/

  public onFileSelected(event, index) {

    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    if (event.target.files.length > 0) {
      this.fileName = event.target.files[0].name;
      this.fileSize = event.target.files[0].size;
      const allowedExtensions = ["jpg", "jpeg", "png", "pdf", "ppt", "pptx", "txt", "doc", "docx", "xlsx", "xls", "csv"];
      this.fileExtension = this.fileName.split('.').pop();

      if (this.isInArray(allowedExtensions, this.fileExtension)) {

        if (this.fileSize > 5242880) {
          this.fileSizeExtensionError = true;
        } else {
          this.fileExtensionError = false;
          this.fileSizeExtensionError = false;

          if (index === 1) {
            this.expenseClaimForm.value.supportingDoc1 = this.fileName;
            this.supportingDoc1Name = this.fileName;
            this.supportingDoc1File = event.target.files[0] as File;
          } else if (index === 2) {
            this.expenseClaimForm.value.supportingDoc2 = this.fileName;
            this.supportingDoc2Name = this.fileName;
            this.supportingDoc2File = event.target.files[0] as File;
          }
        }
      } else {
        this.fileExtensionError = true;
      }
    }
  }

  removeFile(index) {
    if (index === 1) {
      this.expenseClaimForm.value.supportingDoc1 = null;
      this.supportingDoc1Name = this.uploadDocumentConstant;
      this.supportingDoc1File = null;
    } else if (index === 2) {
      this.expenseClaimForm.value.supportingDoc2 = null;
      this.supportingDoc2Name = this.uploadDocumentConstant;
      this.supportingDoc2File = null;
    }
  }

  /** checks if word exists in array
  * @class CreateAndEditExpenseClaimComponent
  * @method isInArray
  */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  /** To save event form
 * @class CreateAndEditExpenseClaimComponent
 * @method saveExpense
 */

  saveExpense(action) {
    this.alertSuccess = false;
    this.alertSuccessOnSave = false;
    this.timeOutError = false;
    this.selectedFiles = [];
    if (this.supportingDoc1Name != null && this.supportingDoc1File != null) {
      this.selectedFiles.push(this.supportingDoc1File);
      this.expenseClaimForm.value.supportingDoc1 = this.supportingDoc1Name;

    }
    if (this.supportingDoc2Name != null && this.supportingDoc2File != null) {
      this.selectedFiles.push(this.supportingDoc2File);
      this.expenseClaimForm.value.supportingDoc2 = this.supportingDoc2Name;

    }

    if (action === 'save') {
      this.expenseClaimForm.value.isSubmitted = false;
      if (this.expenseClaimForm.value.expenseStatus === 'SCHEDULED') {
        this.expenseClaimForm.value.expenseStatus = 'SCHEDULED';
      } else {
        this.expenseClaimForm.value.expenseStatus = 'NEW';
      }
    } else if (action === 'submit') {
      this.expenseClaimForm.value.isSubmitted = true;
      this.expenseClaimForm.value.expenseStatus = 'SUBMITTED';
    }

    this.spinner.show();
    this.expenseClaimForm.value.userID = `${this.loginData.userId}`;
    const expenseFormData = { ...this.expenseClaimForm.value };

    this.bpgExpensesService.saveExpense(expenseFormData).subscribe(data => {
      this.finalExpenseData = data
      this.spinner.hide();
      this.expenseClaimForm.patchValue(data);
      if (this.selectedFiles.length > 0) {
        this.uploadFlag = 'create-expense'
        for (const file of this.selectedFiles) {
          const uploadData =
          {
            'category': 'uploadDocument',
          }
          this.bpgCommonService.getAwsUrl(uploadData).subscribe(async data => {
            this.awsUrls = data;
            await this.uploadService.getPresignedUrl(file, this.awsUrls, this.finalExpenseData.expenseId, this.uploadFlag);
            if (localStorage.getItem('uploadError') !== 'Error') {
              this.alertSuccess = true;


            }

            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinner.hide();
          }, err => {
            this.spinner.hide();
            if (err.value.statusText === ConstantValues.unknownError) {
              this.timeOutError = true;
            }
            setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
          });

        }
      }
      else {
        if (action === 'save') {
          this.alertSuccessOnSave = true;
        } else if (action === 'submit') {
          this.alertSuccess = true;
        }
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          this.router.navigate(['/expense-list']);
        }, 3000);

      }
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
      setTimeout(() => {
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
    });
  }

  /** to select cancel
  * @class CreateAndEditExpenseClaimComponent
  * @method cancelClick
  */
  cancelClick() {
    this.method = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
    this.param = "";
  }

  /** to select confirm
   * @class CreateAndEditExpenseClaimComponent
   * @method submitClick
   */
  saveClick() {
    this.method = "saveExpense";
    this.msg1 = " Do you want to save this expense ?";
    this.param = "save";
  }

  /** to select confirm
    * @class CreateAndEditExpenseClaimComponent
    * @method submitClick
    */
  submitClick() {
    this.method = "saveExpense";
    this.msg1 = " Do you want to submit this expense ?";
    this.param = "submit";
  }

  navigate() {
    sessionStorage.setItem(this.buttonType, "CANCEL");
    this.location.back();
    window.scrollTo(0, 0);
  }

  trimValue(formControl) {
    if (formControl.value != null && formControl.value !== '') {
      formControl.setValue(formControl.value.trim());
    }

  }

  /** To disable form inputs based on hoshin selection
* @class CreateAndEditExpenseClaimComponent
* @method disableInputBasedOnSelection
*/
  public disableInputBasedOnSelection(isExpense) {
    if (isExpense === true) {
      this.expenseClaimForm.controls['eventId'].setValue(null);
      this.expenseClaimForm.controls['eventId'].enable();
    } else if (isExpense === false) {
      this.expenseClaimForm.controls['eventId'].setValue(null);
      this.expenseClaimForm.controls['eventId'].disable();
    }

  }

  public getHoshinItemsBasedOnChapterSelection(chapterId, eventId, hoshinId) {
    this.actionTitleHoshin = "";
    this.expenseClaimForm.controls['hoshinId'].setValue(null);
    this.filter.chapterId = chapterId;
    this.filter.eventId = eventId;
    this.filter.hoshinId = hoshinId;
    this.landingDTOModel.filter = this.filter;
    this.bpgEventService.getHoshinListForDropDown(this.landingDTOModel).subscribe(data => {
      this.HoshinDropDown = data;
      if (this.HoshinDropDown != null) {
        for (const hoshin of this.HoshinDropDown) {
          if (this.HoshinDropDown.length === 1 && hoshin['isMapped'] === true) {

            this.actionTitleHoshin = "DISABLE";
            this.expenseClaimForm.patchValue({
              hoshinId: hoshin['hoshinId']
            });
          }
        }
      }
    }, err => {
      this.spinner.hide();
      if (err.value.statusText === ConstantValues.unknownError) {
        this.timeOutError = true;
      }
    });

  }
}
